import styled, { css } from 'styled-components';
import { marginStyles } from '../../styles/components.js';

const borderRadius = (props) => props.theme.borderRadii.large;
const StyledCard = styled.div `
  background: ${props => props.theme.colors.background.primary};
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: ${borderRadius};

  ${props => marginStyles(props.margin)}

  > *:first-child {
    border-radius: 0;
    border-top-right-radius: ${borderRadius};
    border-top-left-radius: ${borderRadius};
  }

  > *:last-child {
    border-radius: 0;
    border-bottom-right-radius: ${borderRadius};
    border-bottom-left-radius: ${borderRadius};
  }

  ${props => props.theme.media.tabletPortraitDown} {
    ${props => props.mobileVariant === 'flat' &&
    css `
        border-radius: 0;

        > *:first-child {
          border-radius: 0;
        }

        > *:last-child {
          border-radius: 0;
        }
      `}
  }
`;

export { StyledCard };
